export const accelerateBreakpoints = {
  xs: 0, // extra small/phone
  sm: 600, // small/phone
  md: 960, // medium/tablet
  lg: 1280, //large/desktop
  xl: 1920, // extra large/wide desktop
};

export default accelerateBreakpoints;
